import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  saveCarnival,
  getLeadInfraId,
  getProjectOnboardingListing
} from 'services/redux/brandActivtion/conductCamp/action';
import {getClientList} from 'services/redux/sales/projectOnboarding/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import ClientListing from './clientListing';
import {
    getPreSaleListing,
    getStatusList,
    getDealStatusList,
    UpdateLeadStatus,
    getListFilterData,
    fetchZones,
} from "services/redux/sales/preSaleListing/action";
import {
  pocSiteType,
  pocSubSiteType,
  pocType,
} from "services/redux/sales/corporate/pocDetails/action";

const mapStateToProps = (state) => ({
//   pocList: state.ConductCampReducer.pocList,
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  pocSiteTypeData: state.pocTypesReducer.pocSiteTypeData,
  pocSubSiteTypeData: state.pocTypesReducer.pocSubSiteTypeData,
  leadInfraId: state.ConductCampReducer.leadInfraId,
  projectOnboradingListing: state.ConductCampReducer.projectOnboradingListing,
  perSalesList: state.preSalesListReducer.perSalesList,
  statusList: state.preSalesListReducer.statusList,
  dealStatusList: state.preSalesListReducer.dealStatusList,
  filterDropdownList: state.preSalesListReducer.filterDropdownList,
  getFetchZones: state.preSalesListReducer.getFetchZones,
  clientListing: state.projectOnboardingReducer.clientListing
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      documentUploadUrlPublic,
      getLeadInfraId,
      saveCarnival,
      getProjectOnboardingListing,
      getPreSaleListing,
      getStatusList,
      getDealStatusList,
      UpdateLeadStatus,
      getListFilterData,
      fetchZones,
      pocSiteType,
      pocSubSiteType,
      getClientList
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ClientListing);
